/** @format */

// common
export const BodyBg: string = "#ffffff";
export const BodyText: string = "#EBEBEB";
export const SubtleText: string = "#808080";
export const LineText: string = "#E6594F";
export const LinkHoverText: string = "#EE8E87";
export const BaseBg: string = "#262626";
export const BaseText: string = "#EBEBEB";
export const BaseBorder: string = "#5E5E5E";
export const HoverBg: string = "#383838";
export const HoverText: string = "#EBEBEB";
export const HoverBorder: string = BaseBorder;
export const SelectedBg: string = "#003A79";
export const SelectedText: string = "#F5F5F5";
export const SelectedBorder: string = BaseBorder;
export const SelectedHoverBg: string = "#003267";
export const SelectedHoverBorder: string = "#03559A";
export const SelectedHoverText: string = SelectedText;
export const DisabledText: string = "#4D4D4D";

//  color system
export const ColorPrimary: string = "#03559A";
export const ColorPrimaryContrast: string = "white";
export const ColorSecondary: string = "#5C5C5";
export const ColorTertiary: string = "#0398DC";
export const ColorInfo: string = "#004FD2";
export const ColorSuccess: string = "#32A200";
export const ColorWarning: string = "#E6AD00";
export const ColorError: string = "#DB1500";
export const ColorDark: string = "#ffffff";
export const ColorLight: string = "#BDBDBD";
export const ColorInverse: string = "#424242";
export const DesignColorCombination: string = "#01203a, #0358a0";
export const White: string = "#FFFFFF";
export const LoginButton: string = "#0A829D";
export const Button: string = "#BDBCBF";
export const AffBlue: string = "#0A829D";
export const AffBlueGrad: string = "var(--primary-color, #0A829D)";
export const LoginImageBackground: string = "#e3f2fd";
export const LoginHeader: string = "#303132";
export const LoginLabelText: string = "#6B7280";
export const Green: string = "#6B7280";
export const Orange: string = "FFA500";
export const Red: string = "FF0000";
export const Blue: string = "#005FFF";
export const DarkGreen: string = "#0A9D0F";

// Component
export const ComponentBg: string = "#333333";
export const ComponentText: string = "#EBEBEB";
export const ComponentBorder: string = "rgba(0, 0, 0, 0.08)";
export const ComponentHeaderBg: string = BaseBg;
export const ComponentHeaderText: string = BaseText;
export const ComponentHeaderBorder: string = BaseText;
export const InvalidText: string = ColorError;
export const InvalidBorder: string = ColorError;
export const ValidText: string = ColorSuccess;
export const ValidBorder: string = ColorSuccess;

//figma design color
export const SELECTED_AND_SUBMIT_BUTTON_COLOR =
  "linear-gradient(#01203A,0358A0)    ";

//Dashboard
export const DashboardBackground: string = "#F5F8FA";
export const DashboardBorder: string = "1px solid #EAECF0";
export const DashboardHeadTypo: string =
  "var(--Text-Colors-Primary-Text, #374151)";
export const DashboardSearchPlaceholderTypo: string =
  "var(--Text-Colors-Secondary-Text, #6B7280)";
export const SuccessTagBorder: string =
  "1px solid var(--Success-Success-focus-shadow, #C4EEC9)";
export const SuccessTagBackground: string =
  "var(--Success-Success-BG, #F2FBF3)";
export const SuccessTagTextColor: string =
  "var(--Success-Success-color, #2E933C)";
export const ErrorTagBorder: string =
  "1px solid var(--Error-Error-focus-shadow, #FECACA)";
export const ErrorTagBackground: string = "var(--Error-Error-BG, #FFF1F0)";
export const ErrorTagTextColor: string =
  "var(--Error-Error-border-color, #FF3723)";
export const WarningTagBorder: string =
  "1px solid var(--Warning-Warning-focus-shadow, #FFF488)";
export const WarningTagBackground: string =
  "var(--Warning-Warning-BG, #FFFDEB)";
export const WarningTagTextColor: string =
  "var(--Warning-Warning-color, #ED9902)";
export const ActionTextTypo: string =
  "var(--Secondary-color-Secondary-color, #001F3D)";
export const DashboardPaginationBorder: string =
  "0px solid var(--Gray-200, #EAECF0)";

//Dataextraction
export const AccordianBorder: string =
  "1px solid var(--Stroke-Color-Stroke-Default, #E5E7EB)";
export const AccordianBackground: string = "var(--Base-Base-BG-2, #FAFAFA)";
export const BackButtonBGColor: string = "#001F3D";
export const PDFViewerColor: string = "#e0e0e0";
export const PDFViewerBorder: string = "#ccc";

export const DashboardTableCellBorder: string =
  "1px solid rgba(224, 224, 224, 1)";
export const DropdownBackground: string = "#F9FAFB";
export const DropdownBorder: string = "1px solid #D1D5DB";
export const UploadDragBackground: string = "#f9f9f9";
export const GridHeaderBackground: string = "F2F5F8";

//Authwrapper
export const AppTitle: string = "var(--secondary-Color-2, #626668)";

//FileViewer
export const HighlightPDFBorder: string = "2px solid #007BFF";
export const HighlightPDFBorderRemove: string = "1px solid transparent";
export const HighlightPDF: string = "#D1E8FF";
export const HighlightPDFRemove: string = "#F3FDFD";
